<template>
    <p>
        Menampilkan {{ current | number }} dari {{ total | number }} {{ unit }}
    </p>
</template>

<script>
import { get } from 'lodash'

export default {
    computed: {
        current() {
            return Boolean(this.pagination?.current)
                ? this.pagination?.current
                : get(this.pagination, 'per_page', 0)
        },
        total() {
            return get(this.pagination, 'total', 0)
        },
    },
    props: {
        pagination: {
            type: Object,
			required: false,
			default: () => ({}),
        },
        unit: {
            type: String,
			required: false,
			default: 'data',
        },
    },
}
</script>